export const WIN_PLAYER_A = 'WinPlayerA';
export const WIN_PLAYER_B = 'WinPlayerB';
export const PUSH = 'Push';
